if (typeof Range !== 'undefined') {
  const nativeSetEnd = Range.prototype.setEnd;
  Range.prototype.setEnd = function (node, offset) {
    if (node && node.nodeType === Node.ELEMENT_NODE && offset > node.childNodes.length) {
      const textNode = node.firstChild;
      if (textNode && textNode.nodeType === Node.TEXT_NODE) {
        const len = textNode.textContent.length;
        return nativeSetEnd.call(this, textNode, Math.min(offset, len));
      }
      return nativeSetEnd.call(this, node, node.childNodes.length);
    }
    return nativeSetEnd.call(this, node, offset);
  };
}
